import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_URL, UPLOADS_API_URL } from "./config";

const ReceiptQoutation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    customer = {},
    selectedGoods,
    totalAmount,
    operatorName,
    branchName,
    shiftId,
    companyDetails,
    branchDetails,
  } = location.state;

  // Log the received data for debugging
  console.log("Receipt Data:", {
    customer,
    selectedGoods,
    totalAmount,
    operatorName,
    branchName,
    shiftId,
    companyDetails,
    branchDetails,
  });

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="bg-light min-vh-100 py-3">
      <div className="container py-2">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <div
            className="w-100 card shadow-lg p-4"
            style={{
              maxWidth: 900,
              background: "#fff",
            }}
          >
            <div className="d-flex justify-content-center">
              <img
                src={`${
                  companyDetails.horizontal_logo
                    ? `${UPLOADS_API_URL}/${companyDetails.horizontal_logo.replace(
                        /\\/g,
                        "/"
                      )}`
                    : "/assets/images/default-logo.png"
                }`}
                alt={`${companyDetails.trading_name} Logo`}
                className="img-fluid mb-2"
                style={{
                  width: "80%",
                  maxHeight: "120px",
                  objectFit: "contain",
                }}
              />
            </div>

            <div className="text-center w-100">
              <h2 className="mb-1" style={{ color: "blue", fontWeight: 700 }}>
                {companyDetails.trading_name}
              </h2>
              {/* Branch Details Section */}
              {branchDetails.length > 0 && (
                <div className="mb-2">
                  <small>
                    <strong>Branch Name:</strong> {branchDetails[0].branch_name}
                  </small>
                </div>
              )}
              <div className="row align-items-center mb-3">
                <div className="col-6 col-md-4 d-flex justify-content-center">
                  <img
                    src={`${
                      companyDetails.sub_logo
                        ? `${UPLOADS_API_URL}/${companyDetails.sub_logo.replace(
                            /\\/g,
                            "/"
                          )}`
                        : "/assets/images/default-logo.png"
                    }`}
                    alt={`${companyDetails.name} Sub Logo`}
                    className="img-fluid"
                    style={{
                      width: "80%",
                      maxHeight: "90px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div className="col-6 col-md-4 text-md-end text-start">
                  <div className="mb-1">
                    <span className="fw-bold">Date:</span>{" "}
                    <span>{new Date().toLocaleDateString()}</span>
                  </div>
                  <div className="mb-1">
                    <span className="fw-bold">Quotation #:</span>{" "}
                    <span>{shiftId}</span>
                  </div>
                  <div className="mb-1">
                    <span className="fw-bold">Customer ID:</span>{" "}
                    <span>{customer.company_id || "N/A"}</span>
                  </div>
                </div>
                <div className="d-none d-md-block col-md-4"></div>
              </div>
              <hr style={{ backgroundColor: "blue", height: 2, opacity: 1 }} />

              <div className="row gx-2 gy-1 mb-2">
                <div className="col-12 col-md-7">
                  <div className="text-start">
                    <h5 className="fw-bold">
                      Received From: {customer.name || "N/A"}
                    </h5>
                    <div style={{ fontSize: "0.95rem" }}>
                      <div>{customer.address || "N/A"}</div>
                      <div>
                        {customer.phone_number1 || "N/A"}
                        {customer.phone_number2
                          ? " / " + customer.phone_number2
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-1 d-none d-md-block"></div>
                <div className="col-12 col-md-4 text-md-end text-center">
                  <h3
                    className="fw-bolder text-danger text-decoration-underline"
                    style={{
                      fontSize: "2.5rem",
                      letterSpacing: "2px",
                    }}
                  >
                    Quotation
                  </h3>
                </div>
              </div>
              <hr style={{ backgroundColor: "green", height: 2, opacity: 1 }} />
            </div>

            {/* Receipt Items Table */}
            <div className="my-3">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm align-middle mb-0">
                  <thead className="table-primary">
                    <tr>
                      <th style={{ width: 60 }}>#</th>
                      <th>Description</th>
                      <th style={{ minWidth: 120 }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedGoods && selectedGoods.length > 0 ? (
                      selectedGoods.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.product_name}</td>
                          <td>${item.total.toFixed(2)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No items selected.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Quotation Totals */}
            <div className="row justify-content-end">
              <div className="col-12 col-md-6">
                <div className="border rounded-3 p-3 bg-light">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="fw-bold">Total:</div>
                    <div className="fw-bold text-success fs-5">
                      ${totalAmount ? totalAmount.toFixed(2) : "0.00"}
                    </div>
                  </div>
                  {/* Uncomment and adjust if needed
                  <div className="d-flex justify-content-between align-items-center">
                    <div>Sale Total:</div>
                    <div>${totalAmount ? totalAmount.toFixed(2) : "0.00"}</div>
                  </div>
                  */}
                </div>
              </div>
            </div>

            {/* Footer Logos and Branch Details */}
            <div className="row align-items-end mt-4">
              <div className="col-6 col-md-4">
                <img
                  src={`${
                    companyDetails.footer_logo
                      ? `${UPLOADS_API_URL}/${companyDetails.footer_logo.replace(
                          /\\/g,
                          "/"
                        )}`
                      : "/assets/images/default-logo.png"
                  }`}
                  alt={`${companyDetails.trading_name} Footer Logo`}
                  className="img-fluid"
                  style={{
                    width: "80%",
                    maxHeight: "180px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div className="col-6 col-md-8 text-start">
                {branchDetails.length > 0 && (
                  <div style={{ marginTop: "14px" }}>
                    <strong>{branchDetails[0].branch_name}</strong>
                    <br />
                    {companyDetails.address} <br />
                    Phone: {companyDetails.phone_number1}
                    <br />
                    {branchDetails[0].branch_location} <br />
                    {branchDetails[0].branch_city}
                  </div>
                )}
              </div>
            </div>

            {/* Footer with Actions (HIDDEN ON PRINT) */}
            <div className="modal-footer d-flex justify-content-end gap-2 no-print d-print-none mt-4">
              <button
                className="btn btn-danger"
                onClick={() => navigate(-1)}
                type="button"
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handlePrint}
                type="button"
              >
                Print Quotation
              </button>
            </div>

            {/* KEEP YOUR COMMENTED CODE AS-IS */}
            {/* 
            <div style={{ display: "flex", alignSelf: 'end' }}>
              <div style={{ display: "flex", flexDirection: "row", alignSelf: 'right' }}>
                <div style={{ textAlign: "right" }}>
                  <p>
                    Total:{" "}
                    <span style={{ backgroundColor: "skyblue", marginLeft: 20 }}>
                      ${totalAmount.toFixed(2)}
                    </span>
                  </p>
                  <p>
                    Sale Total:{" "}
                    <span
                      style={{ backgroundColor: "skyblue", marginLeft: 70 }}
                    ></span>
                  </p>
                  <p>
                    Total:{" "}
                    <span style={{ backgroundColor: "skyblue", marginLeft: 20 }}>
                      ${totalAmount.toFixed(2)}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            */}
          </div>
        </div>
      </div>
      {/* Print CSS for hiding buttons */}
      <style>
        {`
          @media print {
            .no-print, .no-print * {
              display: none !important;
            }
            .d-print-none, .d-print-none * {
              display: none !important;
            }
            body {
              background: #fff !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ReceiptQoutation;